/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetStaffMemberQueryResponse, GetStaffMemberPathParams, GetStaffMember400, GetStaffMember401, GetStaffMember403, GetStaffMember404, GetStaffMember409, GetStaffMember500 } from "../../types/staffController/GetStaffMember.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetStaffMemberUrl(organizationId: GetStaffMemberPathParams["organizationId"], staffId: GetStaffMemberPathParams["staffId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/staff/${staffId}` as const }
  return res
}

/**
 * @summary Get staff member by ID
 * {@link /api/organizations/:organizationId/staff/:staffId}
 */
export async function getStaffMember(organizationId: GetStaffMemberPathParams["organizationId"], staffId: GetStaffMemberPathParams["staffId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetStaffMemberQueryResponse, ResponseErrorConfig<GetStaffMember400 | GetStaffMember401 | GetStaffMember403 | GetStaffMember404 | GetStaffMember409 | GetStaffMember500>, unknown>({ method : "GET", url : getGetStaffMemberUrl(organizationId, staffId).url.toString(), ... requestConfig })
  return res.data
}